import { render, staticRenderFns } from "./ModalChangeCardName.vue?vue&type=template&id=b5083394&"
import script from "./ModalChangeCardName.vue?vue&type=script&lang=js&"
export * from "./ModalChangeCardName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports